export default "__VITE_ASSET__uClWzED1__"